import React, { useEffect, useState } from 'react'
import { GoDotFill } from 'react-icons/go'

import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'
import { cn } from 'src/lib/utils'
import dayjs from 'dayjs'
import Assessors from '../Risk/MitigationComponents/Assessors'
import ViewTasktable from '../Risk/MitigationComponents/ViewTasktable'
import { useIssueStore } from './store/IssueStore'
import { RESOLUTION_APPROACH, RESOLUTION_ID } from 'src/Entities/IssueTypes'

const IssuePlanning = () => {
    const issueDetailsData = useIssueStore(state => state.issueDetailsById)
    const [ getData, setGetData ] = useState({})
    const { getDepOrganizations, allDepartments } = useGovernanceStore()
    const [ departments, setDepartments ] = useState([])
    const orgId = localStorage.getItem('orgId')
    useEffect(() => {
        if (allDepartments.length > 0) {
            setDepartments(allDepartments)
        }
    }, [allDepartments])

    useEffect(() => {
        if (issueDetailsData?.planningResponse) {
            setGetData(issueDetailsData?.planningResponse)
            getDepOrganizations(orgId)
        }
    }, [issueDetailsData])

    return (
        <div className='text-primary h-[100%] overflow-auto flex flex-col gap-7 p-5'>
            <div className='text-primary text-subHeading-2 p-3 rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'><GoDotFill size={8} /> Resolution Plan</div>
            <div className={cn('flex', getData?.approachId === RESOLUTION_ID ? 'justify-around' : 'justify-start gap-10 pl-4')}>
                <div>
                    <div className='text-primary text-subHeading-2'>
                Approach
                    </div>
                    <div className='text-muted text-b5'>
                        {RESOLUTION_APPROACH?.find((ele) => ele.value === getData?.approachId)?.label}
                    </div>
                </div>
                <div>
                    <div className='text-primary text-subHeading-2'>
                Justification
                    </div>
                    <div className='text-muted text-b5'>
                        {getData?.justification}
                    </div>
                </div>

                {getData?.approachId === RESOLUTION_ID && <div>
                    <div className='text-primary text-subHeading-2' >
                        Resolution Budget
                    </div>
                    <div className='text-muted text-b5'>
                        {getData?.mitigationBudget}
                    </div>
                </div>}
            </div>
            {getData?.approachId === RESOLUTION_ID && <>
                <div className='text-primary text-subHeading-2 p-3 rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'><GoDotFill size={8} />Task List</div>
                <Assessors data={issueDetailsData?.analyzeResponse?.qualitativeRiskAssessment} type='ISSUE'/>
                <div className='flex'>
                    <div className='text-primary text-subHeading-2'>
                        Resolution Date :
                    </div>
                    <div className='text-muted text-b5'>
                        {dayjs(getData?.resolutionDate).format('DD/MM/YYYY')}
                    </div>
                </div>
                <ViewTasktable departments={departments} data={getData?.taskLists?.length > 0 ? getData?.taskLists : issueDetailsData?.riskInformation?.suggestedMitigation} monitoringView={false} />
            </>}
        </div>
    )
}

export default IssuePlanning
